import * as Yup from 'yup';

const schema = Yup.object().shape({
  email: Yup.string()
    .email('Este email não é válido')
    .required('Este campo é obrigatório'),
  password: Yup.string().required('Este campo é obrigatório'),
});

export default schema;
